// extracted by mini-css-extract-plugin
module.exports = {"btnWithAddon":"index_btnWithAddon_3Gbdw","btnAddon":"index_btnAddon_1y8IO","btnAddonIcon":"index_btnAddonIcon_2Bzrn"};